<template>
  <div class="container mt-4">
    <div class="row mt-3">
      <div class="col d-flex justify-content-start">
        <h4>Regenerar</h4>
      </div>
    </div>
    <div class="row card-container">
      <div class="col" style="max-width: 400px;">
        <div class="card bg-light rounded-sm p-3 my-2 border">
          <div class="form-group">
              <label>Ingrese ID de la factura</label>
              <input
                  v-model="saleId"
                  type="number"
                  class="form-control"
                  autocomplete="off"
                  name="id"
                  required>
          </div>
          <div class="form-group">
              <button type="button" class="btn btn-orange btn-lg my-2" @click="reprint">Reimprimir Factura</button>
          </div>
        </div>
      </div>

      </div>
  </div>
</template>

<script>
import axios from 'axios';
import myaxios from 'axios';



export default {
  data: function() {
    return {
        saleId: 0,
    }
  },
  methods: {
    reprint() {
      axios.get('/api/sales/reprintSale/' + this.saleId)
      .then(res => {
        const uninterceptedAxiosInstance = myaxios.create();
          uninterceptedAxiosInstance.get(res.data.data.urlInvoice, { responseType: 'blob' })
          .then((response) => {
            const blob = new Blob([response.data], {type: 'application/pdf'});
            const link = document.createElement('a')
            const currentDate = new Date();
            const formattedDate = currentDate.toLocaleDateString().replace(/\//g, '-');
            link.href = URL.createObjectURL(blob)
            link.download = 'Reimpresion_' + formattedDate + '.pdf';
            link.click()
            URL.revokeObjectURL(link.href)
          })
        })
    }
  }
}
</script>

<style>
.card-container {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
</style>